/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import { Form, FormGroup, Button, Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import {
  SR_RECORD_TO_RECORD_DISPERSION_MODEL,
  SR_MODELING_DISPERSION,
  RESIDUAL_DRIFT_SIMULATION_METHOD,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import GridField from '#components/pages/Models/Model/sections/support/forms/GridField/index.jsx';
import BackButton from '#components/pages/Models/Model/sections/support/buttons/BackButton.jsx';
import NextButton from '#components/pages/Models/Model/sections/support/buttons/NextButton.jsx';
import StructuralResponsesTable from './Table/index.js';
import RecordToRecordSelectMenu from '#components/pages/Models/Model/sections/type2/StructuralResponsesSection/support/RecordToRecordSelectMenu/index.jsx';
import ResidualDriftSimulationMethodSelectMenu from '#components/pages/Models/Model/sections/type2/StructuralResponsesSection/support/ResidualDriftSimulationMethodSelectMenu/index.jsx';

type Props = {|
  form: string,
  heading: string,
  onBack: Function,
  onNext: Function,
|};

const StructuralResponseTableView = (props: Props): Element<'div'> => {
  const { form, heading, onBack, onNext } = props;
  return (
    <Container>
      <Row>
        <Col>
          <h2>{heading}</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="float-right">
            <Button id="addResponse" className="pr-0" to="add" color="link" tag={Link}>
              + Add Response
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <StructuralResponsesTable form={form} />
        </Col>
      </Row>
      <Row className="pt-4">
        <Col>
          <Form novalidate>
            <FormGroup tag="fieldset">
              <legend>Structural Response Dispersion Modeling</legend>
              <GridField
                name={SR_RECORD_TO_RECORD_DISPERSION_MODEL}
                form={form}
                options={{
                  columnSize: 4,
                  labelText: 'Record-to-record Dispersion Model',
                  ComponentType: RecordToRecordSelectMenu,
                  includeToolTip: true,
                }}
              />
              <GridField
                name={SR_MODELING_DISPERSION}
                form={form}
                options={{
                  columnSize: 4,
                  labelText: 'Modeling Dispersion',
                  ComponentType: 'text',
                  includeToolTip: true,
                }}
              />
              <GridField
                name={RESIDUAL_DRIFT_SIMULATION_METHOD}
                form={form}
                options={{
                  columnSize: 4,
                  labelText: 'Residual Drift Simulation Method',
                  ComponentType: ResidualDriftSimulationMethodSelectMenu,
                  includeToolTip: true,
                }}
              />
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="pt-3">
            <BackButton onClick={onBack} />
            <NextButton onClick={onNext} />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default StructuralResponseTableView;
